import { AnyAction } from "redux"
import axios from "axios"
import { sortByDate } from "../../utils/filesList"
import { Dispatch, RNBThunkAction } from "../store.config"
import { RowPayload } from "../../utils/bank"

export const enum BankArchivesActionsEnum {
  SYNC_BANK_TRANSACTIONS_ATTEMPT = "BANK_ARCHIVES/sync_bank_transactions_attempt",
  SYNC_BANK_TRANSACTIONS_SUCCESS = "BANK_ARCHIVES/sync_bank_transactions_success",
  SYNC_BANK_TRANSACTIONS_FAILURE = "BANK_ARCHIVES/sync_bank_transactions_failure",
  SYNC_BANK_TRANSACTIONS_RESET = "BANK_ARCHIVES/sync_bank_transactions_reset",
  GET_ARCHIVES_ATTEMPT = "BANK_ARCHIVES/getArchivesAttempt",
  GET_ARCHIVES_SUCCESS = "BANK_ARCHIVES/getArchivesSuccess",
  GET_ARCHIVES_FAILURE = "BANK_ARCHIVES/getArchivesFailure",
  DOWNLOADING_STATUS_ATTEMPT = "BANK_ARCHIVES/downloadingStatusAttempt",
  DOWNLOADING_STATUS_DOWNLOADING = "BANK_ARCHIVES/downloadingStatusDownloading",
  DOWNLOADING_STATUS_DOWNLOADED = "BANK_ARCHIVES/downloadingStatusDownloaded",
  DOWNLOADING_STATUS_RESET = "BANK_ARCHIVES/downloadingStatusReset",
  DOWNLOADING_STATUS_FAILURE = "BANK_ARCHIVES/downloadingStatusFailure",
  GET_NEW_OPERATIONS_WITHOUT_ARCHIVE_ATTEMPT = "BANK_ARCHIVES/getNewOperationsWithoutArchiveAttempt",
  GET_NEW_OPERATIONS_WITHOUT_ARCHIVE_SUCCESS = "BANK_ARCHIVES/getNewOperationsWithoutArchiveSuccess",
  GET_NEW_OPERATIONS_WITHOUT_ARCHIVE_FAILURE = "BANK_ARCHIVES/getNewOperationsWithoutArchiveFailure",
  GENERATE_ARCHIVE_ATTEMPT = "BANK_ARCHIVES/generateArchiveAttempt",
  GENERATE_ARCHIVE_SUCCESS = "BANK_ARCHIVES/generateArchiveSuccess",
  GENERATE_ARCHIVE_FAILURE = "BANK_ARCHIVES/generateArchiveFailure",
  REGENERATE_BANK_ARCHIVE_ATTEMPT = "BANK_ARCHIVES/regenerateArchiveAttempt",
  REGENERATE_BANK_ARCHIVE_SUCCESS = "BANK_ARCHIVES/regenerateArchiveSuccess",
  REGENERATE_BANK_ARCHIVE_FAILURE = "BANK_ARCHIVES/regenerateArchiveFailure",
  REGENERATE_BANK_ARCHIVE_RESET = "BANK_ARCHIVES/regenerateArchiveReset",
  DELETE_BANK_ARCHIVE_ATTEMPT = "BANK_ARCHIVES/deleteArchiveAttempt",
  DELETE_BANK_ARCHIVE_SUCCESS = "BANK_ARCHIVES/deleteArchiveSuccess",
  DELETE_BANK_ARCHIVE_FAILURE = "BANK_ARCHIVES/deleteArchiveFailure",
  DELETE_BANK_ARCHIVE_RESET = "BANK_ARCHIVES/deleteArchiveReset",
  GET_TRANSACTION_DATE_BOUNDS_SUCCESS = "BANK_ARCHIVES/getTransactionDateBoundsSuccess",
  GET_TRANSACTION_DATE_BOUNDS_FAILURE = "BANK_ARCHIVES/getTransactionDateBoundsFailure",
}
export const syncBankTransactionsFailureAction = () =>
  ({
    type: BankArchivesActionsEnum.SYNC_BANK_TRANSACTIONS_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "bank-account.get-new-operations.error.title",
      bodyKey: "bank-account.get-new-operations.error.body",
    },
  } as const)
export const syncBankTransactionsResetAction = () =>
  ({ type: BankArchivesActionsEnum.SYNC_BANK_TRANSACTIONS_RESET } as const)
export const syncBankTransactionsAttemptAction = () =>
  ({ type: BankArchivesActionsEnum.SYNC_BANK_TRANSACTIONS_ATTEMPT } as const)
export const syncBankTransactionsSuccessAction = () =>
  ({
    type: BankArchivesActionsEnum.SYNC_BANK_TRANSACTIONS_SUCCESS,
  } as const)
export const getArchivesAttempt = () =>
  ({ type: BankArchivesActionsEnum.GET_ARCHIVES_ATTEMPT } as const)
export const getArchivesSuccess = (payload: ArchivesPayload[]) =>
  ({ type: BankArchivesActionsEnum.GET_ARCHIVES_SUCCESS, payload } as const)
export const getArchivesFailure = () =>
  ({ type: BankArchivesActionsEnum.GET_ARCHIVES_FAILURE } as const)
export const downloadingStatusAttempt = () =>
  ({ type: BankArchivesActionsEnum.DOWNLOADING_STATUS_ATTEMPT } as const)
export const downloadingStatusDownloading = () =>
  ({ type: BankArchivesActionsEnum.DOWNLOADING_STATUS_DOWNLOADING } as const)
export const downloadingStatusDownloaded = () =>
  ({ type: BankArchivesActionsEnum.DOWNLOADING_STATUS_DOWNLOADED } as const)
export const downloadingStatusReset = () =>
  ({ type: BankArchivesActionsEnum.DOWNLOADING_STATUS_RESET } as const)
export const downloadingStatusFailure = () =>
  ({ type: BankArchivesActionsEnum.DOWNLOADING_STATUS_FAILURE } as const)
export const getNewOperationsWithoutArchivesAttemptAction = () =>
  ({
    type: BankArchivesActionsEnum.GET_NEW_OPERATIONS_WITHOUT_ARCHIVE_ATTEMPT,
  } as const)
export const getNewOperationsWithoutArchivesFailureAction = () =>
  ({
    type: BankArchivesActionsEnum.GET_NEW_OPERATIONS_WITHOUT_ARCHIVE_FAILURE,
  } as const)
export const getNewOperationsWithoutArchivesSuccessAction = (
  payload: newOperationsWithoutArchive[]
) =>
  ({
    type: BankArchivesActionsEnum.GET_NEW_OPERATIONS_WITHOUT_ARCHIVE_SUCCESS,
    payload,
  } as const)
export const generateArchiveAttemptAction = (fiscalYearId: number) =>
  ({
    type: BankArchivesActionsEnum.GENERATE_ARCHIVE_ATTEMPT,
    fiscalYearId,
  } as const)
export const generateArchiveSuccessAction = (fiscalYearId: number) =>
  ({
    type: BankArchivesActionsEnum.GENERATE_ARCHIVE_SUCCESS,
    fiscalYearId,
  } as const)
export const generateArchiveFailureAction = (
  fiscalYearId: number,
  message: string
) =>
  ({
    type: BankArchivesActionsEnum.GENERATE_ARCHIVE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "archives.table-content.archive.generating-failure.title",
      bodyKey: message,
    },
    fiscalYearId,
  } as const)

export const regenerateBankArchiveAttempt = () =>
  ({
    type: BankArchivesActionsEnum.REGENERATE_BANK_ARCHIVE_ATTEMPT,
  } as const)
export const regenerateBankArchiveSuccess = () =>
  ({
    type: BankArchivesActionsEnum.REGENERATE_BANK_ARCHIVE_SUCCESS,
  } as const)
export const regenerateBankArchiveReset = () =>
  ({
    type: BankArchivesActionsEnum.REGENERATE_BANK_ARCHIVE_RESET,
  } as const)
export const regenerateBankArchiveFailure = () =>
  ({
    type: BankArchivesActionsEnum.REGENERATE_BANK_ARCHIVE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "bank-management.archives.regenerate-archive-modal.error.title",
      bodyKey:
        "bank-management.archives.regenerate-archive-modal.error.message",
    },
  } as const)

export const deleteBankArchiveAttempt = () =>
  ({
    type: BankArchivesActionsEnum.DELETE_BANK_ARCHIVE_ATTEMPT,
  } as const)
export const deleteBankArchiveSuccess = () =>
  ({
    type: BankArchivesActionsEnum.DELETE_BANK_ARCHIVE_SUCCESS,
  } as const)
export const deleteBankArchiveFailure = () =>
  ({
    type: BankArchivesActionsEnum.DELETE_BANK_ARCHIVE_FAILURE,
    withToast: true,
    toasterType: "error",
    message: {
      titleKey: "bank-management.archives.delete-archive-modal.error.title",
      bodyKey: "bank-management.archives.delete-archive-modal.error.message",
    },
  } as const)
export const deleteBankArchiveReset = () =>
  ({
    type: BankArchivesActionsEnum.DELETE_BANK_ARCHIVE_RESET,
  } as const)
export const getTransactionDateBoundsSuccessAction = (payload: {
  min_date: string
  max_date: string
}) =>
  ({
    type: BankArchivesActionsEnum.GET_TRANSACTION_DATE_BOUNDS_SUCCESS,
    payload,
  } as const)
export const getTransactionDateBoundsFailureAction = () =>
  ({
    type: BankArchivesActionsEnum.GET_TRANSACTION_DATE_BOUNDS_FAILURE,
  } as const)

export type BankArchivesActionsType = ReturnType<
  | typeof syncBankTransactionsAttemptAction
  | typeof syncBankTransactionsSuccessAction
  | typeof syncBankTransactionsFailureAction
  | typeof syncBankTransactionsResetAction
  | typeof getArchivesAttempt
  | typeof getArchivesSuccess
  | typeof getArchivesFailure
  | typeof downloadingStatusAttempt
  | typeof downloadingStatusDownloading
  | typeof downloadingStatusDownloaded
  | typeof downloadingStatusReset
  | typeof downloadingStatusFailure
  | typeof getNewOperationsWithoutArchivesAttemptAction
  | typeof getNewOperationsWithoutArchivesSuccessAction
  | typeof getNewOperationsWithoutArchivesFailureAction
  | typeof generateArchiveAttemptAction
  | typeof generateArchiveSuccessAction
  | typeof generateArchiveFailureAction
  | typeof regenerateBankArchiveAttempt
  | typeof regenerateBankArchiveSuccess
  | typeof regenerateBankArchiveFailure
  | typeof regenerateBankArchiveReset
  | typeof deleteBankArchiveAttempt
  | typeof deleteBankArchiveSuccess
  | typeof deleteBankArchiveFailure
  | typeof deleteBankArchiveReset
  | typeof getTransactionDateBoundsSuccessAction
  | typeof getTransactionDateBoundsFailureAction
>

export const SyncBankTransactionsThunk =
  (accountId: number, fiduciaryId: number, companyId: number, itemId: number) =>
  (dispatch: Dispatch<BankArchivesActionsType>) => {
    dispatch(syncBankTransactionsResetAction())
    dispatch(syncBankTransactionsAttemptAction())
    return axios
      .post(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/${itemId}/bank_accounts/${accountId}/sync_bank_transactions`
      )
      .then(() => {
        dispatch(syncBankTransactionsSuccessAction())
      })
      .catch(() => {
        dispatch(syncBankTransactionsFailureAction())
      })
  }

interface NewOperationsWithoutArchiveResponse {
  fiscal_year_id: number
  count: number
  begin_exercise: string
  end_exercise: string
}

export const getNewOperationsWithoutArchivesThunk =
  (accountId: number, timeOut?: number) =>
  (dispatch: Dispatch<BankArchivesActionsType>) => {
    dispatch(getNewOperationsWithoutArchivesAttemptAction())
    return axios
      .get<NewOperationsWithoutArchiveResponse[]>(
        `/bank_accounts/${accountId}/count_new_transactions`
      )
      .then((response) => {
        if (response.data.length > 0) {
          const operations: newOperationsWithoutArchive[] = response.data.map(
            (o) => {
              return {
                fiscalYearId: o.fiscal_year_id,
                newTransactionsCount: o.count,
                begin_exercise: o.begin_exercise,
                end_exercise: o.end_exercise,
                status: "NOT_GENERATED",
              }
            }
          )
          setTimeout(() => {
            dispatch(getNewOperationsWithoutArchivesSuccessAction(operations))
          }, timeOut || 0)
        }
      })
      .catch(() => {
        dispatch(getNewOperationsWithoutArchivesFailureAction())
      })
  }

export const generateArchiveThunk =
  (
    fiscalYearId: number,
    {
      fiduciaryId,
      companyId,
      bankItemId,
      bankAccountId,
      generate_choice,
      start_date,
      end_date,
    }: ArchivesParams
  ) =>
  (dispatch: Dispatch<BankArchivesActionsType | RNBThunkAction>) => {
    dispatch(generateArchiveAttemptAction(fiscalYearId))
    const timeOut = 1500
    return axios
      .post(`/bank_accounts/${bankAccountId}/list_transactions`, {
        fiscal_year_id: fiscalYearId,
        generate_choice: generate_choice,
        ...(start_date ? { start_date } : {}),
        ...(end_date ? { end_date } : {}),
      })
      .then(() => {
        dispatch(getNewOperationsWithoutArchivesThunk(bankAccountId, timeOut))
        dispatch(
          getArchivesThunk(
            { fiduciaryId, companyId, bankItemId, bankAccountId },
            timeOut
          )
        )
      })
      .then(() => {
        setTimeout(() => {
          dispatch(generateArchiveSuccessAction(fiscalYearId))
        }, timeOut)
      })
      .catch((error) => {
        let message = "archives.table-content.archive.generating-failure.body"
        if (error.response.data.error.includes("no transactions to generate")) {
          message += ".no_transaction"
        }
        setTimeout(() => {
          dispatch(generateArchiveFailureAction(fiscalYearId, message))
        }, timeOut)
      })
  }

export const regenerateBankArchiveThunk =
  ({ bankArchiveId }: { bankArchiveId: number }) =>
  (dispatch: Dispatch<BankArchivesActionsType | RNBThunkAction>) => {
    dispatch(regenerateBankArchiveAttempt())

    const timeOut = 2000

    return axios
      .post(`/bank_archives/${bankArchiveId}/regenerate`)
      .then(() => {
        setTimeout(() => {
          dispatch(regenerateBankArchiveSuccess())
        }, timeOut)
      })
      .catch(() => {
        dispatch(regenerateBankArchiveFailure())
      })
  }

export const deleteBankArchiveThunk =
  ({ bankArchiveId }: { bankArchiveId: number }) =>
  (dispatch: Dispatch<BankArchivesActionsType | RNBThunkAction>) => {
    dispatch(deleteBankArchiveAttempt())

    return axios
      .post(`/bank_archives/${bankArchiveId}/delete_archive`)
      .then(() => {
        dispatch(deleteBankArchiveSuccess())
      })
      .catch(() => {
        dispatch(deleteBankArchiveFailure())
      })
  }

export const getArchivesThunk =
  (
    { fiduciaryId, companyId, bankItemId, bankAccountId }: ArchivesParams,
    timeOut?: number
  ) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(getArchivesAttempt())
    return axios
      .get<ArchivesResponse>(
        `/fiduciaries/${fiduciaryId}/companies/${companyId}/bank_items/${bankItemId}/bank_accounts/${bankAccountId}/list_archives`
      )
      .then(({ data }) => {
        const archivesFormatted = Object.values(data)[0].map(
          (archive: ArchivesResponse) => ({
            archiveId: archive.id,
            created_at: archive.created_at,
            downloadedAt: archive.downloaded_at,
            downloadUserId: archive.download_user_id,
            downloadFirstName: archive.first_name,
            downloadLastName: archive.last_name,
            fiscalYearId: archive.fiscal_year_id,
            fileName: archive.file_name,
            begin_exercise: archive.begin_exercise,
            end_exercise: archive.end_exercise,
            accountId: bankAccountId,
            count_bank_transaction: archive.count_bank_transaction,
            status: archive.generated_at ? "GENERATED" : "GENERATING",
            generated_at: archive.generated_at,
          })
        )
        setTimeout(() => {
          dispatch(
            getArchivesSuccess(
              archivesFormatted.sort((a: RowPayload, b: RowPayload) =>
                sortByDate(a.created_at, b.created_at)
              )
            )
          )
        }, timeOut || 0)
      })
      .catch(() => {
        dispatch(getArchivesFailure())
      })
  }

export const getTransactionsDateBoundsThunk =
  (accountId: number, fiscalYearId: number) =>
  (dispatch: Dispatch<AnyAction>) => {
    return axios
      .get<{ min_date: string; max_date: string }>(
        `/bank_accounts/${accountId}/get_transactions_date_bounds`,
        { params: { fiscal_year_id: fiscalYearId } }
      )
      .then(({ data }) => {
        dispatch(getTransactionDateBoundsSuccessAction(data))
        return data
      })
      .catch(() => {
        dispatch(getTransactionDateBoundsFailureAction())
      })
  }

export const getArchiveUrlThunk =
  ({
    id,
    companyName,
    accountSoftwareReference,
    accountSoftware,
  }: ArchiveUrlParams) =>
  (dispatch: Dispatch<AnyAction>) => {
    dispatch(downloadingStatusAttempt())
    dispatch(downloadingStatusDownloading())
    const requestURI = `/bank_archives/${id}/download`
    const params = {}
    return axios
      .post<ArchiveRequestPayload>(requestURI, params, {
        withCredentials: false,
      })
      .then((response) => {
        generateDownloadFileName(
          response.data["s3_url"],
          companyName,
          id,
          accountSoftwareReference,
          accountSoftware
        ).then(() => {
          dispatch(downloadingStatusDownloaded())
          setTimeout(() => {
            dispatch(downloadingStatusReset())
          }, 7000)
        })
      })
      .catch(() => {
        dispatch(downloadingStatusFailure())
      })
  }

const generateDownloadFileName = (
  fileLink: string,
  companyName: string,
  archiveId: number,
  accountSoftwareReference: string,
  accountSoftware: string
) => {
  return axios
    .get<Blob>(fileLink, { responseType: "blob", withCredentials: false })
    .then((response) => {
      var blob = new Blob([response.data])
      var downloadElement = document.createElement("a")
      var href = window.URL.createObjectURL(blob)
      downloadElement.href = href
      if (
        accountSoftwareReference &&
        (accountSoftware === "cegid" || accountSoftware === "quadratus")
      ) {
        downloadElement.download = `${accountSoftwareReference}_${archiveId}.zip`
      } else {
        downloadElement.download = `${companyName} Archive N${archiveId}.zip`
      }
      document.body.appendChild(downloadElement)
      downloadElement.click()
      document.body.removeChild(downloadElement)
      window.URL.revokeObjectURL(href)
    })
}

interface ArchivesParams {
  fiduciaryId: number
  companyId: number
  bankItemId: number
  bankAccountId: number
  generate_choice?: GenerateChoice
  start_date?: string
  end_date?: string
}
export type GenerateChoice =
  | "all"
  | "all_except_no_full_doc"
  | "all_except_no_assignment"
  | "all_except_no_full_doc_and_no_assignment"
interface ArchivesResponse {
  id: number
  created_at: string
  downloaded_at: string
  download_user_id: number
  first_name: string
  last_name: string
  fiscal_year_id: number
  file_name: string
  begin_exercise: string
  end_exercise: string
  count_bank_transaction: number[]
  generated_at: string | null
}

interface ArchiveUrlParams {
  id: number
  companyName: string
  accountSoftwareReference: string
  accountSoftware: string
}

interface ArchiveRequestPayload {
  s3_url: string
  company_name: string
}
export interface ArchivesPayload {
  id: number
  creationDate: string
  downloadDate: string
  downloadUserId: number
  downloadFirstName: string
  downloadLastName: string
  fiscalYearId: number
  fileName: string
}

export interface newOperationsWithoutArchive {
  newTransactionsCount: number
  fiscalYearId: number
  begin_exercise: string
  end_exercise: string
  status: GenerationStatus
}

export type GenerationStatus =
  | "NOT_GENERATED"
  | "GENERATING"
  | "GENERATED"
  | "DOWNLOADING"
  | "DOWNLOADED"
